const floorplans = [
  {
    plan: 'A1',
    level:'Levels 19-47',
    type: '1 BR',
    bed: 1,
    den: false,
    others: [
      {
        view: 'W',
        priceRanges: [790000, 830000, 870000]
      }
    ],
  },
  {
    plan: 'A2',
    level:'Levels 19-52',
    type: '1 BR',
    bed: 1,
    den: false,
    others: [
      {
        view: 'E',
        priceRanges: [795000,825000,855000]
      }
    ],
  },
  {
    plan: 'A3',
    level:'Levels 19-52',
    type: '1 BR',
    bed: 1,
    den: false,
    others: [
      {
        view: 'E',
        priceRanges: [805000,835000,865000]
      }
    ],
  },
  {
    plan: 'A4',
    level:'Levels 19-52',
    type: '1 BR',
    bed: 1,
    den: false,
    others: [
      {
        view: 'E',
        priceRanges: [790000,820000,850000]
      }
    ],
  },
  {
    plan: 'A5',
    level:'Levels 4-18',
    type: '1 BR',
    bed: 1,
    den: false,
    others: [
      {
        view: 'E',
        priceRanges: [765000,780000]
      }
    ],
  },
  {
    plan: 'B1',
    level:'Levels 4-18',
    type: '2 BR',
    bed: 2,
    den: false,
    others: [
      {
        view: 'NW',
        priceRanges: [1005000,1055000,1105000]
      },
      {
        view: 'SW',
        priceRanges: [990000,1030000,1070000]
      }
    ],
  },
  {
    plan: 'B2',
    level:'Levels 19-52',
    type: '2 BR',
    bed: 2,
    den: false,
    others: [
      {
        view: 'NW',
        priceRanges: [1170000,1280000,1390000]
      },
      {
        view: 'SW',
        priceRanges: [1125000,1210000,1295000]
      }
    ],
  },
  {
    plan: 'B3',
    level:'Levels 4-18',
    type: '2 BR',
    bed: 2,
    den: false,
    others: [
      {
        view: 'N',
        priceRanges: [915000,950000,985000]
      },
      {
        view: 'S',
        priceRanges: [930000,965000,1000000]
      }
    ],
  },
  {
    plan: 'B4',
    level:'Levels 19-52',
    type: '2 BR',
    bed: 2,
    den: false,
    others: [
      {
        view: 'N',
        priceRanges: [1025000,1085000,1145000]
      },
      {
        view: 'S',
        priceRanges: [1030000,1075000,1120000]
      }
    ],
  },
  {
    plan: 'BB1',
    level:'Levels 4-52',
    type: '2 BR + D',
    bed: 2,
    den: true,
    others: [
      {
        view: 'SE',
        priceRanges: [1190000,1310000,1430000]
      }
    ],
  },
  {
    plan: 'BB2',
    level:'Levels 4-52',
    type: '2 BR + D',
    bed: 2,
    den: true,
    others: [
      {
        view: 'NE',
        priceRanges: [1175000,1285000,1395000]
      }
    ],
  },
  {
    plan: 'BB3',
    level:'Levels 48-52',
    type: '2 BR + D',
    bed: 2,
    den: true,
    others: [
      {
        view: 'W',
        priceRanges: [1555000,1595000,1635000]
      }
    ],
  },
  // {
  //   plan: 'PH1',
  //   level:'Level 53',
  //   type: '2 BR + D',
  //   bed: 2,
  //   den: true,
  //   others: [
  //     {
  //       view: 'NE',
  //       priceRanges: [3000000]
  //     }
  //   ],
  // },
  // {
  //   plan: 'PH2',
  //   level:'Level 53',
  //   type: '2 BR + D',
  //   bed: 2,
  //   den: true,
  //   others: [
  //     {
  //       view: 'SE',
  //       priceRanges: [3030000]
  //     }
  //   ],
  // },
  // {
  //   plan: 'PH3',
  //   level:'Level 53',
  //   type: '2 BR + D',
  //   bed: 2,
  //   den: true,
  //   others: [
  //     {
  //       view: 'W',
  //       priceRanges: [3100000]
  //     }
  //   ],
  // },
  {
    plan: 'C1',
    level:'Levels 4-18',
    type: '3 BR',
    bed: 3,
    den: false,
    others: [
      {
        view: 'E',
        priceRanges: [1340000,1390000,1440000]
      },
      {
        view: 'W',
        priceRanges: [1340000,1400000,1460000]
      }
    ]
  },
  {
    plan: 'C2',
    level:'Level 23',
    type: '3 BR',
    bed: 3,
    den: false,
    others: [
      {
        view: 'SW',
        priceRanges: [1530000]
      }
    ],
  },
  
  // {
  //   plan: 'A3',
  //   type: '1 BR + D',
  //   bed: 1,
  //   den: true,
  //   others: [
  //     {
  //       view: 'N',
  //       priceRanges: [695000, 730000, 765000]
  //     },
  //     {
  //       view: 'S',
  //       priceRanges: [725000, 780000, 835000]
  //     }
  //   ],
  // },
  // {
  //   plan: 'B2',
  //   type: '2 BR',
  //   bed: 2,
  //   den: true,
  //   others: [
  //     {
  //       view: 'E',
  //       priceRanges: [825000, 845000, 865000]
  //     },
  //   ],
  // },
  // {
  //   plan: 'B4',
  //   type: '2 BR',
  //   bed: 2,
  //   den: true,
  //   others: [
  //     {
  //       view: 'E',
  //       priceRanges: [905000, 925000, 945000]
  //     },
  //   ],
  // }
];

export default floorplans;

// const floorplans = [
//   { "plan": "ST1", "type": "Studio", "view": "S", "priceRanges": [485000, 520000, 555000] },
//   { "plan": "AA1", "type": "1 BR", "view": "W", "priceRanges": [460000] },
//   { "plan": "AA3", "type": "1 BR", "view": "S", "priceRanges": [580000, 610000, 640000] },
//   { "plan": "AA4", "type": "1 BR", "view": "S", "priceRanges": [635000, 640000] },
//   { "plan": "AA4", "type": "1 BR", "view": "SW", "priceRanges": [615000, 620000] },
//   { "plan": "AA5", "type": "1 BR", "view": "S", "priceRanges": [685000, 710000, 735000] },
//   { "plan": "AA6", "type": "1 BR", "view": "W", "priceRanges": [615000, 625000, 635000] },
//   { "plan": "AA7", "type": "1 BR", "view": "W", "priceRanges": [660000, 665000, 670000] },
//   { "plan": "AA8", "type": "1 BR", "view": "W", "priceRanges": [630000, 645000, 660000] },
//   { "plan": "AA9", "type": "1 BR", "view": "N", "priceRanges": [660000, 670000, 680000] },
//   { "plan": "AA10", "type": "1 BR", "view": "W", "priceRanges": [640000, 665000, 690000] },
//   { "plan": "AA11", "type": "1 BR", "view": "N", "priceRanges": [695000, 705000, 715000] }, 
//   { "plan": "AA12", "type": "1 BR", "view": "NW", "priceRanges": [705000, 720000, 735000] }, 
//   { "plan": "AA13", "type": "1 BR", "view": "S", "priceRanges": [750000, 750000, 750000] }, 
//   { "plan": "PHA1", "type": "1 BR", "view": "N", "priceRanges": [915000] }, 
//   { "plan": "PHA2", "type": "1 BR", "view": "N", "priceRanges": [955000] }, 
//   { "plan": "A2", "type": "1 BR + D", "view": "E", "priceRanges": [700000, 720000, 740000] }, 
//   { "plan": "A2", "type": "1 BR + D", "view": "N", "priceRanges": [700000, 735000, 770000] }, 
//   { "plan": "A2", "type": "1 BR + D", "view": "S", "priceRanges": [700000, 735000, 770000] }, 
//   { "plan": "A3", "type": "1 BR + D", "view": "N", "priceRanges": [695000, 730000, 765000] }, 
//   { "plan": "A3", "type": "1 BR + D", "view": "S", "priceRanges": [725000, 780000, 835000] }, 
//   { "plan": "A4", "type": "1 BR + D", "view": "N", "priceRanges": [700000, 720000, 740000] }, 
//   { "plan": "A5", "type": "1 BR + D", "view": "W", "priceRanges": [690000] }, 
//   { "plan": "A7", "type": "1 BR + D", "view": "N", "priceRanges": [735000, 755000, 775000] }, 
//   { "plan": "A8", "type": "1 BR + D", "view": "SW", "priceRanges": [775000, 810000, 845000] }, 
//   { "plan": "PHA3", "type": "1 BR + D", "view": "N", "priceRanges": [1090000] }, 
//   { "plan": "B2", "type": "2 BR", "view": "E", "priceRanges": [825000, 845000, 865000] }, 
//   { "plan": "B4", "type": "2 BR", "view": "E", "priceRanges": [905000, 925000, 945000] }, 
//   { "plan": "CC1", "type": "2 BR", "view": "W", "priceRanges": [755000] }, 
//   { "plan": "CC2", "type": "2 BR", "view": "NW", "priceRanges": [835000, 855000, 875000] }, 
//   { "plan": "CC3", "type": "2 BR", "view": "SW", "priceRanges": [955000, 985000, 1015000] }, 
//   { "plan": "CC6", "type": "2 BR", "view": "S", "priceRanges": [1115000, 1145000, 1175000] }, 
//   { "plan": "CC7", "type": "2 BR", "view": "N", "priceRanges": [915000, 955000, 995000] }, 
//   { "plan": "CC8", "type": "2 BR", "view": "NW", "priceRanges": [1010000, 1045000, 1080000] }, 
//   { "plan": "CC9", "type": "2 BR", "view": "NWS", "priceRanges": [1140000] }, 
//   { "plan": "CC9", "type": "2 BR", "view": "S", "priceRanges": [1080000] }, 
//   { "plan": "PHC2", "type": "2 BR", "view": "NW", "priceRanges": [1645000] }, 
//   { "plan": "PHC3", "type": "2 BR", "view": "N", "priceRanges": [1525000, 1540000, 1555000] }, 
//   { "plan": "B1", "type": "2 BR + D", "view": "E", "priceRanges": [725000, 755000, 785000] }, 
//   { "plan": "B1", "type": "2 BR + D", "view": "S", "priceRanges": [730000, 760000, 790000] }, 
//   { "plan": "C1", "type": "2 BR + D", "view": "S", "priceRanges": [895000, 925000, 955000] }, 
//   { "plan": "C2", "type": "2 BR + D", "view": "E", "priceRanges": [945000, 970000, 995000] }, 
//   { "plan": "C2", "type": "2 BR + D", "view": "S", "priceRanges": [950000, 975000, 1000000] }, 
//   { "plan": "C3", "type": "2 BR + D", "view": "S", "priceRanges": [1005000, 1045000, 1085000] }, 
//   { "plan": "C4", "type": "2 BR + D", "view": "N", "priceRanges": [940000, 970000, 1000000] }, 
//   { "plan": "C8", "type": "2 BR + D", "view": "NE", "priceRanges": [1055000, 1095000, 1135000] }, 
//   { "plan": "C11", "type": "2 BR + D", "view": "SE", "priceRanges": [1085000, 1120000, 1155000] }, 
//   { "plan": "PHC1", "type": "2 BR + D", "view": "N", "priceRanges": [1505000] }, 
//   { "plan": "D1", "type": "3 BR", "view": "E", "priceRanges": [1015000, 1040000, 1065000] }, 
//   { "plan": "D3", "type": "3 BR", "view": "SE", "priceRanges": [1535000, 1605000, 1675000] }, 
//   { "plan": "EE2", "type": "3 BR", "view": "E", "priceRanges": [1195000, 1215000, 1235000] }, 
//   { "plan": "TH1", "type": "3 BR", "view": "W", "priceRanges": [1295000, 1330000, 1365000] }, 
//   { "plan": "PHC5", "type": "3 BR", "view": "N", "priceRanges": [1565000] }, 
//   { "plan": "PHE3", "type": "3 BR + D", "view": "N", "priceRanges": [1760000] }, 
//   { "plan": "PHE5", "type": "3 BR + D", "view": "NE", "priceRanges": [1990000] }, 
//   { "plan": "TH2", "type": "3 BR + D", "view": "W", "priceRanges": [1315000] }, 
//   { "plan": "F1", "type": "4 BR", "view": "W", "priceRanges": [1490000] }
// ],
